import React from "react";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { IRAInsulinCoachmarkType } from "../../@types";
import { useTranslate } from "../../helpers";
import { InsulinCoachmark } from "./InsulinCoachmark";

export const insulinDrugCoachmarkTestid = "insulin-drug-coachmark";

export const InsulinDrugCoachmark = () => {
  const t = useTranslate();

  return (
    <InsulinCoachmark
      coachmarkType={IRAInsulinCoachmarkType.DRUG_LIST}
      className="mct-c-insulin-drug-coachmark"
      dataTestId={insulinDrugCoachmarkTestid}
      title={t("coachmark.insulin.drug.title")}
      body={
        <ul>
          <li>
            <FormattedHTMLMessage id="coachmark.insulin.drug.body.list.one" />
          </li>
          <li>
            <FormattedHTMLMessage id="coachmark.insulin.drug.body.list.two" />
          </li>
          <li>
            <FormattedHTMLMessage id="coachmark.insulin.drug.body.list.three" />
          </li>
        </ul>
      }
    />
  );
};
